<template>
  <div>
    <BaseAccordion
      class="the-menu__navigation-accordion ui-accordion-primary"
    >
      <template #title>
        <span class="the-menu__item-accordion">{{t('common.language') }}</span>
      </template>


      <template #content>
        <ul class="accordion__list language-switcher__list">
          <li
            class="language-switcher__item"
            v-for="language in languageOptions"
            :key="language.value"
            @click="changeLanguage(language.value)"
          >
            <BaseIcon2
              :class="language.value === locale? '' : 'color-white'"
              id="icon-check"
              color="var(--grey-2)"
              height="16"
              width="16"
            />
            <span class="language-switcher__item-name">{{ language.name }}</span>
          </li>
        </ul>
      </template>
    </BaseAccordion>
  </div>
</template>


<script lang="ts" setup>
const { locale, locales, t } = useI18n();

const languageOptions = computed(() =>
  locales.value?.map((language) => ({
    name: language.name,
    value: language.code,
  })) || []
);


async function changeLanguage(langCode: string) {
  if (langCode == locale.value) {
    return;
  }

  // Handle URL navigation with locale prefixes
  const router = useRouter();
  const route = useRoute();
  const currentPath = route.fullPath;
  const supportedLocales = languageOptions.value.map(lang => lang.value);

  // Check if the current path starts with a locale prefix
  const hasLocalePrefix = supportedLocales.some(locale =>
    currentPath.startsWith(`/${locale}/`) || currentPath === `/${locale}`
  );

  if (hasLocalePrefix) {
    // Replace the current locale prefix with the new one
    const newPath = supportedLocales.reduce((path, locale) => {
      if (path.startsWith(`/${locale}/`)) {
        return `/${langCode}/${path.slice(locale.length + 2)}`;
      }
      if (path === `/${locale}`) {
        return `/${langCode}`;
      }
      return path;
    }, currentPath);

    // Navigate to the new path
    router.push(newPath);
  } else {
    // If no locale prefix, add the new one
    router.push(`/${langCode}${currentPath}`);
  }
}
</script>

<style scoped>
.accordion__list {
  display: flex;
  flex-direction: column;
  row-gap: 8px;
  margin-top: 8px;
}

.language-switcher__item {
  display: flex;
  align-items: center;
  padding: 8px 12px;
  column-gap: 14px;
  cursor: pointer;
  transition: background-color 0.2s ease;
}

.color-white {
  color: var(--white) !important;
}

.language-switcher__item-name {
  color: var(--grey-1);
  font-size: 12px;
}
</style>
